import VehicleCodeButton from './VehicleCodeButton'
import vehicleCodeButtonContainer from './vehicleCodeButtonContainer'

export default vehicleCodeButtonContainer(VehicleCodeButton)
